import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { FileProvider } from "./context/filecontext";
import HomePage from "./pages/homepages";
import UploadPage from "./pages/fileupload";
import ProtectedRoute from "./components/ProtectedRoute";
import Notification from "./components/Notification";
import FileListingPage from "./pages/scannedfiles";
import SearchFilePage from "./pages/searchmodifiedanalysis";
import SearchReport from "./pages/searchreport";
import Layout from "./components/Layout";
import FileViewerPage from "./pages/fileviewer";

const App = () => {
  async function callApi() {
    const response = await fetch("http://127.0.0.1:8000/run-processes/");

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      let v = decoder.decode(value)
      console.log(v);
      // convert string to json
      v = JSON.parse(v)
      console.log(v)
      console.log(v.message)
    }

    console.log("Streaming finished.");
  }

  // callApi();
  return (
    <FileProvider>
      <Layout>
        <Notification />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/search" element={<SearchFilePage />} />
          <Route path="/report" element={<SearchReport />} />
          <Route path="/files" element={<FileListingPage />} />
          <Route
            path="/viewer"
            element={
              <ProtectedRoute>
                <FileViewerPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/upload" replace />} />
        </Routes>
      </Layout>
    </FileProvider>
  );
};

export default App;
